import { Button, FormControl, Grid } from "@material-ui/core";
import { Box, CssBaseline, InputLabel, MenuItem, Paper, Select, Stack, Table, TableContainer, TableHead, TextField, Toolbar, styled } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import React, { useRef, useState } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CamIcon from "@mui/icons-material/CameraAlt"

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonImage = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    color: '#ffff',
    margin: '0px 1rem',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});

export default function CrearCreditos(){
    const fileInputRef = useRef(null);
    const fileDocumentTop = useRef(null);
    const fileDocumentBack = useRef(null);
    const fileSelfie = useRef(null);
    const [commerces, setCommerces] = useState([{
        oldId: 1,
        name: "Commerce"
    }]);
    

    return (
        <React.Fragment>
            <CssBaseline></CssBaseline>
            <Toolbar></Toolbar>
            <Box sx={{width: '100%'}}>
                <Stack spacing={2}>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container>
                        <Grid item>
                            <Box display={'flex'}>
                                <h1>Creación de créditos</h1>
                            </Box>
                        </Grid>
                    </Grid>
                    <Box container sx={{width:'75vw'}}>
                        <form >
                            <Box width={'100%'} mb={2}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de Originación"></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="numero-identificacion" label="Número de identificación" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="nombres" label="Nombres cliente" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="apellidos" label="Apellidos cliente" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="numero-celular" label="Número de celular" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="ocupacion" label="Ocupación" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker label="Fecha de nacimiento"></DatePicker>
                                    </LocalizationProvider>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="direccion-residencia" label="Dirección de residencia" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="ciudad-residencia" label="Ciudad/Municipio de residencia" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="expedicion-documento" label="Lugar de expedición del documento" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="expedicion-documento" label="Lugar de expedición del documento" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="autorizacion-tratamiento-de-datos" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>Autorización tratamiento de datos</InputLabel>
                                    <ButtonImage onClick={(e) => fileInputRef.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileInputRef}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="foto-cedula" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>Foto frontal cédula</InputLabel>
                                    <ButtonImage onClick={(e) => fileDocumentTop.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileDocumentTop}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="foto-cedula-back" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>Foto trasera cédula</InputLabel>
                                    <ButtonImage onClick={(e) => fileDocumentBack.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileDocumentBack}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="foto-cedula-back" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>Foto trasera cédula</InputLabel>
                                    <ButtonImage onClick={(e) => fileDocumentBack.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileDocumentBack}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <InputLabel id="foto-selfie" sx={{marginBottom: '1rem', marginLeft: '1rem'}}>Selfie</InputLabel>
                                    <ButtonImage onClick={(e) => fileSelfie.current?.click()}>
                                        <input accept="image/*" type="file" multiple hidden ref={fileSelfie}></input>
                                        Cargar imagen
                                        <CamIcon sx={{marginLeft: '1rem'}}></CamIcon>
                                    </ButtonImage>
                                </FormControl>
                            </Box>
                            <Box mt={5} >
                                <FormControl fullWidth>
                                    <InputLabel id="commerce-id">Id Comercio</InputLabel>
                                    <Select labelId="commerce-id" id="select-commerceId" label="Id Comercio">
                                        {commerces?.map(commerce => (
                                            <MenuItem key={commerce.oldId} value={commerce.oldId}>{`${commerce.oldId}. ${commerce.name}`}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box width={'100%'} mt={5} mb={2}>
                                <FormControl fullWidth>
                                    <TextField id="ingresos" label="Ingresos estimados finales" variant="outlined"></TextField>
                                </FormControl>
                            </Box>
                        </form>
                    </Box>
                </Stack>
            </Box>
            <Box sx={{width: '100%'}}>
                
            </Box>
        </React.Fragment>
    )
}